import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';

export const getMessage = (
  t: TTranslator<TLocalesKeys>,
  alias: string,
  isPerMinute: boolean | undefined,
  penaltyMode: boolean,
  clientPenalty: number,
  remainingSeconds: number
): string => {
  if (isPerMinute) {
    return t('host.penalty.message.minute');
  }

  if (penaltyMode) {
    return t('host.penalty.message', alias, clientPenalty);
  }

  if (remainingSeconds <= 60) {
    return t('host.penalty.message.finish', '<1');
  }

  return t('host.penalty.message.finish', Math.floor(remainingSeconds / 60));
};
